import {
  GET_LABREQUESTASSIGNMENT,
  GET_LABREQUESTASSIGNMENT_FAIL,
  GET_LABREQUESTASSIGNMENT_SUCCESS,
  GET_LABREQUESTASSIGNMENTS,
  GET_LABREQUESTASSIGNMENTS_FAIL,
  GET_LABREQUESTASSIGNMENTS_SUCCESS,
  ADD_NEW_LABREQUESTASSIGNMENT,
  ADD_LABREQUESTASSIGNMENT_SUCCESS,
  ADD_LABREQUESTASSIGNMENT_FAIL,
  UPDATE_LABREQUESTASSIGNMENT,
  UPDATE_LABREQUESTASSIGNMENT_SUCCESS,
  UPDATE_LABREQUESTASSIGNMENT_FAIL,
  DELETE_LABREQUESTASSIGNMENT,
  DELETE_LABREQUESTASSIGNMENT_SUCCESS,
  DELETE_LABREQUESTASSIGNMENT_FAIL,
  SET_STATE_LABREQUESTASSIGNMENT
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTASSIGNMENT,
  payload: loading,
})

export const getLabRequestAssignments = ( params ) => ({
  type: GET_LABREQUESTASSIGNMENTS,
  payload: { params },
})

export const getLabRequestAssignmentsSuccess = (labRequestAssignments, totalPages, currentPage) => ({
  type: GET_LABREQUESTASSIGNMENTS_SUCCESS,
  payload: { labRequestAssignments:labRequestAssignments, total:totalPages, currentPage:currentPage}
})

export const getLabRequestAssignmentsFail = error => ({
  type: GET_LABREQUESTASSIGNMENTS_FAIL,
  payload: error,
})

export const addNewLabRequestAssignment = labRequestAssignment => ({
  type: ADD_NEW_LABREQUESTASSIGNMENT,
  payload: labRequestAssignment,
})

export const addLabRequestAssignmentSuccess = labRequestAssignment => ({
  type: ADD_LABREQUESTASSIGNMENT_SUCCESS,
  payload: labRequestAssignment,
})  

export const addLabRequestAssignmentFail = error => ({
  type: ADD_LABREQUESTASSIGNMENT_FAIL,
  payload: error,
})

export const updateLabRequestAssignment = labRequestAssignment => ({
  type: UPDATE_LABREQUESTASSIGNMENT,
  payload: labRequestAssignment,
})

export const updateLabRequestAssignmentSuccess = labRequestAssignment => ({
  type: UPDATE_LABREQUESTASSIGNMENT_SUCCESS,
  payload: labRequestAssignment,
})

export const updateLabRequestAssignmentFail = error => ({
  type: UPDATE_LABREQUESTASSIGNMENT_FAIL,
  payload: error,
})

export const deleteLabRequestAssignment = labRequestAssignment => ({
  type: DELETE_LABREQUESTASSIGNMENT,
  payload: labRequestAssignment,
})

export const deleteLabRequestAssignmentSuccess = id => ({
  type: DELETE_LABREQUESTASSIGNMENT_SUCCESS,
  id,
})

export const deleteLabRequestAssignmentFail = error => ({
  type: DELETE_LABREQUESTASSIGNMENT_FAIL,
  payload: error,
})

export const getLabRequestAssignment = () => ({
  type: GET_LABREQUESTASSIGNMENT,
})

export const getLabRequestAssignmentSuccess = labRequestAssignment => ({
  type: GET_LABREQUESTASSIGNMENT_SUCCESS,
  payload: labRequestAssignment,
})

export const getLabRequestAssignmentFail = error => ({
  type: GET_LABREQUESTASSIGNMENT_FAIL,
  payload: error,
})
